import React from 'react';
import { motion } from 'framer-motion';

interface LiveBadgeProps {
    isConnected: boolean;
}

export const LiveBadge: React.FC<LiveBadgeProps> = ({ isConnected }) => {
    return (
        <div className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[var(--bg)] border border-[var(--border)]">
            <motion.span
                className={`w-1.5 h-1.5 rounded-full ${
                    isConnected ? 'bg-[var(--status-up)]' : 'bg-[var(--status-warn)]'
                }`}
                animate={isConnected ? { scale: [1, 1.2, 1], opacity: [1, 0.7, 1] } : {}}
                transition={{ duration: 2, repeat: Infinity }}
            />
            <span className="text-[10px] font-medium text-[var(--text-secondary)] uppercase tracking-wider">
                {isConnected ? 'Live' : 'Stale'}
            </span>
        </div>
    );
};